import React from "react";

const CartIcon = ({name, color, size}) => (
    <svg viewBox="0 0 32 32" className={`icon icon-cart`} fill={color} width={size} height={size}  xmlns="http://www.w3.org/2000/svg">
        <path d="M3.904 5.395V31.5h24.474V5.395H3.904zM25.93 29.053H6.351V7.842H25.93v21.211zM6.351.5v4.895H25.93V.5H6.351zm17.132 4.895H8.799V2.948h14.684v2.447z" />
        <path d="M19.893 10.289v2.692c0 2.692-.816 3.671-3.753 3.671s-3.753-.979-3.753-3.671v-2.692h-1.958v3.1c0 3.753 1.632 5.058 5.711 5.058s5.711-1.305 5.711-5.058v-3.1h-1.958z" />
    </svg>
);

export default CartIcon;